import type { GroupMessageDto } from '../services/GroupService';
import { playMessageNotificationSound } from './playMessageNotificationSound';

/**
 * Ao sincronizar mensagens do grupo: toca som se houver mensagem nova de terceiros.
 * skipOnceRef: primeira aplicação após abrir o grupo (histórico inicial) não dispara som.
 */
export function maybePlayIncomingGroupMessageSound(
  prev: GroupMessageDto[],
  merged: GroupMessageDto[],
  skipOnceRef: { current: boolean }
): void {
  if (skipOnceRef.current) {
    skipOnceRef.current = false;
    return;
  }
  const prevIds = new Set(prev.map((m) => m.id));
  for (const m of merged) {
    if (!prevIds.has(m.id) && !m.sentByUs) {
      playMessageNotificationSound();
      return;
    }
  }
}
